var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleanedtry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_2",
    "data-name": "katman 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.4 289.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "katman_1",
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.83,
    y: 0.13,
    width: 141.73,
    height: 289.13,
    strokeWidth: "0px",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.83,
    y: 0.13,
    width: 141.73,
    height: 289.13,
    fill: "none",
    stroke: "#1e1e1c",
    strokeWidth: ".25px"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(37.36 236.35)",
    fontSize: "15px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".06em"
  }, "SK"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.8,
    y: 0,
    letterSpacing: ".06em"
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    x: 20.75,
    y: 0,
    letterSpacing: ".06em"
  }, "NNY"), /*#__PURE__*/React.createElement("tspan", {
    x: 47.05,
    y: 0,
    letterSpacing: ".21em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 53.8,
    y: 0,
    letterSpacing: ".06em"
  }, "FI"), /*#__PURE__*/React.createElement("tspan", {
    x: 65.32,
    y: 0
  }, "T")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(132.66 102.15) rotate(-180)",
    fill: "#98989a"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".08em"
  }, "0000/"), /*#__PURE__*/React.createElement("tspan", {
    x: 23.38,
    y: 0,
    letterSpacing: ".08em"
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 28.41,
    y: 0,
    letterSpacing: ".08em"
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    x: 33.45,
    y: 0,
    letterSpacing: "0em"
  }, "0")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    y1: 114.28,
    x2: 0.8,
    y2: 114.28
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.4,
    y1: 114.28,
    x2: 145.8,
    y2: 114.28,
    stroke: "#d51b1f",
    strokeMiterlimit: 10,
    strokeWidth: ".56px",
    strokeDasharray: "0 0 1.6 1.6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.6,
    y1: 114.28,
    x2: 147.4,
    y2: 114.28
  }), /*#__PURE__*/React.createElement("line", {
    y1: 97.27,
    x2: 0.8,
    y2: 97.27
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.4,
    y1: 97.27,
    x2: 145.8,
    y2: 97.27,
    stroke: "#d51b1f",
    strokeMiterlimit: 10,
    strokeWidth: ".56px",
    strokeDasharray: "0 0 1.6 1.6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.6,
    y1: 97.27,
    x2: 147.4,
    y2: 97.27
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(28.27 100.86) rotate(-180)",
    fontSize: "13px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".06em"
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.44,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("path", {
    d: "M96.17,177.42l-.03-.07c-.4-.98-.98-1.85-1.71-2.61l-.25-.25-.04-.04,4.94-13.63,6.03,16.59h-8.94ZM77.84,171.24v-16.85h3.85c5.14,0,7.85,3.05,7.85,8.83,0,6.14-1.56,8.02-6.66,8.02h-5.04ZM52.7,177.45l6.02-16.58,6.02,16.58h-12.04ZM115.74,189.82l-13.89-36.65-.02-.07h-.21l-7.68,21.16c-1.74-1.54-4.2-2.5-7.29-2.86l-.94-.1.93-.11c5.1-.92,8.54-4.14,8.54-8.02,0-5.32-5.01-9.04-12.18-9.04h-15.11v.27h4.34v27.06l-10.76-28.33h-.2l-13.29,36.63h-.07c-.45.06-.9.09-1.34.09h-10.71l20.96-35.72h-25.42v10.96h.27c.05-5.34,3.16-10.69,10.02-10.69h8.69l-21.01,35.73h27.76v-10.5h-.27c-.04,4.65-2.67,9.07-8.4,10.07l-.18.03,4.37-12.01h12.25l4.35,12.1h-4.27v.27h17.25v-.27h-4.36v-18.31h5.04c5.13,0,8.07,2.29,8.07,6.28v3.25c0,.36.02.88.05,1.32h0s-2.71,7.46-2.71,7.46h-3.54v.26h7.32v-.26h-3.5l2.47-6.77v.1s.07.61.07.61l.07.4c.41,2.5,1.37,4.34,2.84,5.46l.21.15c1.12.78,2.51,1.17,4.13,1.17,2.15,0,3.59-.54,4.77-1.8l-.16-.15c-1.09,1-2.01,1.42-3.15,1.42-1.96,0-2.98-2.37-2.98-4.71v-4.55c0-1.2-.18-2.32-.52-3.33l-.05-.14h8.97l4.36,12.13h-4.32v.26h14.77v-.26h-4.32Z",
    fill: "#f5f2f1"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(43.24 265.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".06em"
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.44,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(42.39 275.06)",
    fill: "#898a8d",
    fontFamily: "HelveticaNeueLTStd-Cn, 'Helvetica Neue LT Std'",
    fontSize: "9px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".08em"
  }, "EU"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.28,
    y: 0
  }, "R")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(66.87 265.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".06em"
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.44,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(65.95 275.06)",
    fill: "#898a8d",
    fontFamily: "HelveticaNeueLTStd-Cn, 'Helvetica Neue LT Std'",
    fontSize: "9px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".08em"
  }, "US"), /*#__PURE__*/React.createElement("tspan", {
    x: 10.61,
    y: 0
  }, "A")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(90.45 265.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".06em"
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.44,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(88.94 275.06)",
    fill: "#898a8d",
    fontFamily: "HelveticaNeueLTStd-Cn, 'Helvetica Neue LT Std'",
    fontSize: "9px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".08em"
  }, "ME"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.94,
    y: 0,
    letterSpacing: "0em"
  }, "X")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(131.6 18.19) rotate(-180)",
    fontSize: "20px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".06em"
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.44,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(132.6 68.66) rotate(-180)",
    fontFamily: "HelveticaNeueLTStd-BdCn, 'HelveticaNeueLTStd BdCn'",
    fontSize: "8px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    letterSpacing: ".06em"
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.42,
    y: 0,
    letterSpacing: ".06em"
  }, "K"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.23,
    y: 0,
    letterSpacing: ".06em"
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.62,
    y: 0,
    letterSpacing: ".06em"
  }, "NNY"), /*#__PURE__*/React.createElement("tspan", {
    x: 27.91,
    y: 0,
    letterSpacing: ".21em"
  }), /*#__PURE__*/React.createElement("tspan", {
    x: 31.29,
    y: 0,
    letterSpacing: ".06em"
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    x: 35.66,
    y: 0,
    letterSpacing: ".06em"
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    x: 38.05,
    y: 0
  }, "T"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanedtry);
export default __webpack_public_path__ + "static/media/cleanedtry.e0ba7409d48eb507ff36a2d74505c69e.svg";
export { ForwardRef as ReactComponent };